import { jsx as p } from "react/jsx-runtime";
import { twJoin as h } from "tailwind-merge";
import { semanticOrder as f } from "./toolbar-semantic-order.mjs";
const i = ({
  extension: n,
  source: o,
  skipRef: l,
  withRightBorder: a,
  inTooltip: e
}) => {
  const t = o.filter((r) => r.key === n);
  return t.length ? t.map((r, d) => /* @__PURE__ */ p(
    "div",
    {
      ref: l ? void 0 : r.ref,
      className: h(
        d === t.length - 1 && a && "border-text-secondary/30 border-r last-of-type:border-r-0",
        "flex items-center",
        !e && "px-px first-of-type:pl-0 last-of-type:pr-0"
      ),
      children: e ? r.toolbarItem.tooltipRender : r.toolbarItem.toolbarRender
    },
    r.id
  )) : null;
}, y = ({
  source: n,
  skipBorder: o,
  skipRef: l,
  inTooltip: a
}) => f.flatMap((e, t) => {
  const r = t === f.length - 1;
  return Array.isArray(e) ? e.flatMap((d, s) => i({
    extension: d,
    source: n,
    skipRef: l,
    withRightBorder: !o && !r && s === e.length - 1,
    inTooltip: a
  })) : i({
    extension: e,
    source: n,
    skipRef: l,
    withRightBorder: !o && !r,
    inTooltip: a
  });
});
export {
  y as renderInSemanticOrder
};
